import React from "react";
import { Instagram as IGIcon, Heart, MessageCircle, Bookmark } from "lucide-react";
import { instagramPosts, LOGO_URL } from "../mock";

export default function Instagram() {
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center gap-3 mb-10 reveal">
          <IGIcon className="w-5 h-5 text-[#ee6c4d]" />
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#ee6c4d]">Live from Instagram</span>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {instagramPosts.map((p, i) => (
            <div key={i} className={`bg-white rounded-2xl overflow-hidden border border-orange-100/60 shadow-[0_18px_40px_-25px_rgba(18,43,69,0.2)] hover:-translate-y-1 transition-transform duration-300 ${i === 0 ? "reveal-left" : "reveal-right"}`}>
              <div className="flex items-center justify-between px-4 py-3">
                <div className="flex items-center gap-3">
                  <img src={LOGO_URL} alt="logo" className="w-9 h-9 rounded-full object-cover ring-2 ring-orange-200" />
                  <div>
                    <div className="font-semibold text-sm text-[#122b45]">nanhe.kadam</div>
                    <div className="text-xs text-slate-400">Patna, Bihar</div>
                  </div>
                </div>
                <IGIcon className="w-5 h-5 text-slate-400" />
              </div>
              <div className="aspect-square bg-orange-50">
                <img src={p.img} alt="Instagram" className="w-full h-full object-cover" />
              </div>
              <div className="px-4 py-4">
                <div className="flex items-center gap-4 text-[#122b45]">
                  <Heart className="w-5 h-5" />
                  <MessageCircle className="w-5 h-5" />
                  <Bookmark className="w-5 h-5 ml-auto" />
                </div>
                <div className="mt-2 text-sm font-semibold text-[#122b45]">{p.likes} likes</div>
                <p className="mt-1 text-sm text-slate-600">
                  <span className="font-semibold text-[#122b45]">nanhe.kadam</span> {p.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
